import { Box, CardActionArea, makeStyles, Paper, Typography } from "@material-ui/core";
import React from "react";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';


const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    typo: {
        marginLeft: 10
    }
});

interface DomainCardProps {
    name: string;
    description: string;
    kind: string;
}


export const DomainCard = ({ name, description, kind }: DomainCardProps
) => {
    const classes = useStyles();
    return (
        <Box marginBottom={1}>
            <Paper variant="outlined">
                <Card className={classes.root}>
                    <CardActionArea href={`/catalog/default/${kind}/${name}`}>
                        <CardContent>
                            <Typography gutterBottom variant="h2" className={classes.typo}>
                                <strong>{name}</strong>
                            </Typography>
                            <Typography variant="body1" component="p">
                                <strong>{description}</strong>
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Paper>
        </Box>
    )
}